import { render, staticRenderFns } from "./LicenseAuthenticationCodeInput.vue?vue&type=template&id=5b55ed45"
import script from "./LicenseAuthenticationCodeInput.vue?vue&type=script&lang=js"
export * from "./LicenseAuthenticationCodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports